import React from "react";
import Footer from './Footer'
import NaviBarv2 from './NaviBarv2'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container, Row, Col, Card, ListGroup, ListGroupItem, Button, Tab, Nav,
OverlayTrigger, Popover, Placeholder} from 'react-bootstrap';


export function Krivorotko_Zvonareva_teaching () {
  return (
        <>
    <NaviBarv2 />
    <Container>
      <section>
        <div class="row my-4 text-center"><h1>Семинары курса "Векторный и тензорный анализ"</h1></div>

<div class="row my-4 ps-4"><p class="lead">Курс на <a rel="noopener" target="_blank" href="https://www.nsu.ru/n/physics-department/departments/kafedra-vysshey-matematiki/">кафедре высшей математики</a> Новосибирского государственного университета для студентов 3 курса.</p></div>
<div class="row my-4 ps-4"><p class="lead">Авторы: <a rel="noopener" target="_blank" href="/Krivorotko_info">Криворотько О.И.</a>, <a rel="noopener" target="_blank" href="/Zvonareva_info">Звонарева Т.А.</a>.</p></div>
<div class="row my-4 ps-4"><p class="lead">Учебные пособия: <br></br><a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Криворотько_О_И_,_Звонарева_Т_А_Учебно_методическое_пособие_Векторный.pdf">Криворотько О.И., Звонарева Т.А. Учебно-методическое пособие Векторный и тензорный анализ. НГУ, 2021</a>.<br></br> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Аюпова_Н_Б_Лекции_по_векторному_и_тензорному_анализу.pdf">Аюпова Н.Б. Лекции по векторному и тензорному анализу. НГУ, 2012</a>.</p></div>

       <div class="row my-4 ps-4"><p class="lead">Далее приведено содержание семинаров, ссылки в названии тем ведут на файлы семинаров в формате pdf.</p></div>
       <div class="row my-4 ps-4"><p class="lead"><b>1.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 1-2.pdf">Тензор, преобразования тензора. Главные оси и главные значения тензора. Инварианты.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>2.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 3.pdf">Симметризация и антисимметризация.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>3.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 4.pdf">Неортогональные базисы и общее определение тензора. Операции над тензорами: сложение, произведение, свертка, симметрирование и антисимметрирование.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>4.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 5-6.pdf">Метрический тензор. Основные понятия и свойства.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>5.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 7.pdf">Тензорные поля. Криволинейные системы координат. Коэффициенты Ламе.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>6.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 8-9.pdf">Тензорные поля. Криволинейные системы координат и преобразование тензора. Градиент, дивергенция векторного поля, лапласиан, ротор.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>7.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 10-11.pdf">Понятие геодезических линий. Символы Кристоффеля и их свойства. Ковариантная производная.</a></p></div>

</section>
        </Container>
        

    <Footer />
    </>
    
    )}